var _circle, _path, _circle2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVpPerson = function SvgVpPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 125 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 62.5,
    cy: 62.5,
    r: 62.5,
    fill: "#8CB3DC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.86 60.078h59.081A62.525 62.525 0 0 0 84.126 3.862L65.859 60.078ZM65.86 64.96l18.266 56.216a62.533 62.533 0 0 0 40.825-56.216H65.859ZM61.216 66.47l-47.808 34.733a62.607 62.607 0 0 0 66.074 21.485L61.216 66.469ZM10.534 27.783a62.537 62.537 0 0 0 0 69.472l47.82-34.736-47.82-34.736ZM61.216 58.569 79.482 2.353a62.468 62.468 0 0 0-66.074 21.484L61.216 58.57Z",
    fill: "#8CB3DC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.875,
    cy: 62.875,
    r: 46.875,
    fill: "#1A5CA3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#vp-person_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.265 45.122c-1.322-1.716-2.662-2.4-3.365-2.663-.113-.047-.103-.215.018-.234l.985-.15c.094-.01.131-.122.084-.188-.965-1.312-3.656-2.775-6.956-2.887-5.531 0-7.575 2.813-7.875 4.2a.66.66 0 0 1-.628.516c-1.2.056-3.563.965-1.481 7.697l.347.309h2.09v-1.416l2.044-1.125.215-1.678h8.279l.834 2.11 1.35.468v1.331H70.784a6.84 6.84 0 0 1 1.472-4.293c.469-.59.469-1.416.01-1.997Z",
    fill: "#BBDAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.265 45.122c-1.322-1.716-2.662-2.4-3.365-2.663-.113-.047-.103-.215.018-.234l.985-.15c.094-.01.131-.122.084-.188-.965-1.312-3.656-2.775-6.956-2.887-5.531 0-7.575 2.813-7.875 4.2a.66.66 0 0 1-.628.516c-1.2.056-3.563.965-1.481 7.697l.347.309h2.09v-1.416l2.044-1.125.215-1.678h8.279l.834 2.11 1.35.468v1.331H70.784a6.84 6.84 0 0 1 1.472-4.293c.469-.59.469-1.416.01-1.997Z",
    fill: "#053249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.675 79.462h4.603v6.666L50 87h24l.778-.581v-6.732h4.153l.882-.665v-4.547c0-2.672-1.707-4.997-3.77-5.85-.29-.113-3.75-1.453-6.468-2.503l-1.04.253-1.922.937h-9.516l-1.64-1.209h-1.05l-6.45 2.522c-1.613.665-3.77 2.756-3.77 5.85v4.547l.488.44Z",
    fill: "#99EDBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.022 64.65a.688.688 0 0 1-.16-.44v-2.288l-.43-.188h-7.013l-.272.178v2.297a.67.67 0 0 1-.16.45v.32l2.466 2.043-.14.487.102.272h3.188l.206-.375-.16-.534 2.382-1.866-.01-.356Z",
    fill: "#FED1A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62 61.725h-3.59l-.273.178V64.2a.67.67 0 0 1-.159.45v.319l2.466 2.044-.141.487.103.272H62v-6.047Z",
    fill: "#FFBC85"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M60.678 67.763h2.644V87h-2.644V67.763Z",
    fill: "#57C975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.678 67.763H62V87h-1.322V67.763ZM64.606 69.263a.678.678 0 0 0 1.003.14l3.966-3.29c-1.688-.657-3.094-1.2-3.272-1.266a.687.687 0 0 1-.281-.206l-2.428 2.025a.683.683 0 0 0-.132.909l1.144 1.688ZM58.39 69.412a.685.685 0 0 0 1.004-.14l1.144-1.688a.683.683 0 0 0-.132-.909l-2.428-2.016a.807.807 0 0 1-.131.122l-3.44 1.322 3.984 3.31ZM44.675 79.462h2.588v-5.54c0-2.963 1.312-4.885 2.446-5.99l-1.762.683c-1.603.675-3.76 2.766-3.76 5.86v4.547l.488.44Z",
    fill: "#57C975"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M60.106 43.716a.68.68 0 0 0 .628-.516c.234-1.088 1.547-3.056 4.781-3.853A12.119 12.119 0 0 0 63.031 39c-5.531 0-7.575 2.813-7.875 4.2a.66.66 0 0 1-.628.516c-1.2.056-3.563.965-1.481 7.697l.347.309h2.09v-1.416l2.044-1.125.215-1.678h.066c-.206-3.206 1.378-3.74 2.297-3.787Z",
    fill: "#35495E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.781 53.681c0 1.613 1.425 2.925 3.235 2.644l.272-.347v-4.575l-.272-.375c-1.82-.262-3.235 1.04-3.235 2.653Z",
    fill: "#FED1A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.797 53.681c0-1.012.562-1.903 1.425-2.353l-.206-.29c-1.81-.272-3.235 1.03-3.235 2.643 0 1.613 1.425 2.925 3.235 2.644l.215-.281a2.65 2.65 0 0 1-1.434-2.363Z",
    fill: "#FFBC85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68.956 51.038-.234.215v4.81l.234.262c1.819.272 3.234-1.04 3.234-2.644 0-1.65-1.65-2.859-3.234-2.643Z",
    fill: "#FED1A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.737 51.384a2.93 2.93 0 0 0-1.78-.347l-.235.216v4.81l.234.262a2.874 2.874 0 0 0 1.781-.272v-4.669Z",
    fill: "#FFBC85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.675 79.022c-.375 0-.675.3-.675.675V87h4.556c.694 0 1.257-.562 1.257-1.256v-6.722h-5.138ZM49.325 79.022h-5.138v6.722c0 .694.563 1.256 1.257 1.256H50v-7.303c0-.375-.3-.675-.675-.675Z",
    fill: "#FED1A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.31 49.5a1.3 1.3 0 0 1-1.304-1.303c0-.666-.45-1.247-1.087-1.406a15.69 15.69 0 0 0-6.984-.197v9.534c0 3.028 1.771 5.466 4.256 6.516.169.075.337.14.506.197.384-.094.75-.216 1.106-.375a6.841 6.841 0 0 0 4.163-6.3v-6.01a.664.664 0 0 0-.656-.656Z",
    fill: "#FFE5C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2 62.456c-2.428-1.031-4.162-3.422-4.162-6.366v-9.534a18.9 18.9 0 0 0-.994.225 1.463 1.463 0 0 0-1.088 1.406 1.3 1.3 0 0 1-1.303 1.303.648.648 0 0 0-.647.647v6.02a6.826 6.826 0 0 0 4.163 6.3c1.566.693 3.384.721 4.828.29a6.245 6.245 0 0 1-.797-.29Z",
    fill: "#FED1A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.263 79.022h-3.075v6.722c0 .694.562 1.256 1.256 1.256h1.819v-7.978Z",
    fill: "#FFBC85"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "vp-person_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(38 39)",
    d: "M0 0h48v48H0z"
  })))));
};
export default SvgVpPerson;